export const prayerLabels = {
  asr: "ʿAṣr",
  dhuhr: "Dhuhr",
  fajr: "Fajr",
  isha: "ʿIshāʾ",
  lastThirdOfTheNight: "Last 1/3 Night",
  maghrib: "Maġrib",
  middleOfTheNight: "1/2 Night",
  sunrise: "Sunrise",
} as const;

export type PrayerEvent = keyof typeof prayerLabels;

export type PrayerTiming = {
  event: PrayerEvent;
  isFard: boolean;
  label: string;
  time: string;
  value: Date;
};

export type PrayerMethodValue =
  | "Dubai"
  | "Egyptian"
  | "Karachi"
  | "Kuwait"
  | "MoonsightingCommittee"
  | "MuslimWorldLeague"
  | "NorthAmerica"
  | "Other"
  | "Qatar"
  | "Singapore"
  | "Turkey"
  | "UmmAlQura";

export type PrayerMethodOption = {
  label: string;
  value: PrayerMethodValue;
};

export type PrayerMethodConfig = {
  method: PrayerMethodValue;
  fajrAngle: number;
  ishaAngle: number;
  ishaInterval: number;
};

export type PrayerLocation = {
  id: string;
  label: string;
  city: string;
  country: string;
  continent: string;
  lat: number;
  lon: number;
  timeZone: string;
};

export type PrayerSnapshot = {
  activeEvent: PrayerEvent | null;
  dateLabel: string;
  localTimeLabel: string;
  locationId: string;
  nextEvent: PrayerEvent | null;
  nextEventTime: Date | null;
  timings: PrayerTiming[];
  timezoneLabel: string;
};
